export const navLinks = [
  { name: 'Home', href: '#home' },
  { name: 'Sleep Apnea', href: '/sleep-apnea-treatment', isRoute: true },
  { name: 'Services', href: '#services' },
  { name: 'Smile Gallery', href: '#gallery' },
  { name: 'About', href: '#about' },
  { name: 'Blog', href: '#blog' },
  { name: 'FAQ', href: '#faq' },
  { name: 'Contact', href: '#contact' },
];

export const heroFeatures = [
  { text: 'Sleep Apnea Dentist', color: 'bg-cyan-500' },
  { text: 'Same-Day Crowns', color: 'bg-amber-400' },
  { text: 'Family Dentistry', color: 'bg-amber-500' },
  { text: 'Emergency Care', color: 'bg-amber-600' },
];

export const services = [
  {
    id: 1,
    title: 'Preventative Care',
    description: 'Protect your smile with comprehensive preventative care including regular exams, professional cleanings, and dental sealants to maintain optimal oral health.',
    icon: 'Shield',
  },
  {
    id: 2,
    title: 'Sleep Apnea Solutions',
    description: 'Do you wake up refreshed in the morning? Sleeping well affects your entire day, including behavior and mood. When you wake up feeling tired and irritable, you may have a sleeping disorder. There are dental treatments available to help you sleep better and breathe easier.',
    icon: 'Moon',
  },
  {
    id: 3,
    title: 'Orthodontics',
    description: 'Straighten your teeth discreetly with modern clear aligner technology including Invisalign and Clear Correct.',
    icon: 'Layers',
  },
  {
    id: 4,
    title: 'Teeth Whitening',
    description: 'Professional whitening treatments for a brighter, more radiant smile.',
    icon: 'Sparkles',
  },
  {
    id: 5,
    title: 'Same-Day Crowns (CEREC)',
    description: 'Advanced technology allows us to create and place crowns in a single visit.',
    icon: 'Crown',
  },
  {
    id: 6,
    title: 'Porcelain Veneers',
    description: 'Transform your smile with custom-crafted veneers for a flawless appearance.',
    icon: 'Gem',
  },
  {
    id: 7,
    title: 'Emergency Dental Care',
    description: 'Same-day appointments available for dental emergencies and pain relief.',
    icon: 'Zap',
  },
  {
    id: 8,
    title: 'Restorative Dentistry',
    description: 'Comprehensive care including crowns, fillings, bridges, and root canals.',
    icon: 'RefreshCw',
  },
  {
    id: 9,
    title: 'Oral Surgery',
    description: 'Expert surgical procedures including extractions, bone grafting, and wisdom teeth removal.',
    icon: 'Scissors',
  },
  {
    id: 10,
    title: 'Dental Implants',
    description: 'Permanent, natural-looking tooth replacement solutions that restore your smile and confidence.',
    icon: 'CircleDot',
  },
];

export const transformations = [
  {
    id: 1,
    name: "Mrs. C's Transformation",
    beforeImage: 'https://roseville-smile-revamp.lovable.app/assets/bc-before-g_TnsuxE.jpg',
    afterImage: 'https://customer-assets.emergentagent.com/job_roseville-dental/artifacts/086vilsc_Mrs%20C%20cropped.jpg',
    description: "Mrs. C was tired of her chipped and broken teeth. She wanted to create a beautiful smile. Together with Dr. Yang, they were able to achieve a result she was proud to show off! Dr. Yang works individually with each patient to ensure that their final results are what they want.",
  },
  {
    id: 2,
    name: "Josh's Journey",
    beforeImage: 'https://roseville-smile-revamp.lovable.app/assets/jg-before-DgJu4kvW.jpg',
    afterImage: 'https://roseville-smile-revamp.lovable.app/assets/jg-after-l7DYRolB.jpg',
    description: "Josh came to us wanting a complete smile makeover. After careful planning and treatment, he now has the confident smile he always wanted.",
  },
  {
    id: 3,
    name: "Karen's Confidence",
    beforeImage: 'https://roseville-smile-revamp.lovable.app/assets/km-before-BIngbVaO.jpg',
    afterImage: 'https://roseville-smile-revamp.lovable.app/assets/km-after-Bfrf6VpU.jpg',
    description: "Karen's journey to a beautiful smile has transformed her confidence. She now smiles freely without hesitation.",
  },
  {
    id: 4,
    name: "JC's Experience",
    beforeImage: 'https://roseville-smile-revamp.lovable.app/assets/jc-before-bKDQI3hQ.jpg',
    afterImage: 'https://roseville-smile-revamp.lovable.app/assets/jc-after-jTitBJ-G.jpg',
    description: "JC's dental transformation showcases the quality care provided at Sunshine Dental Care.",
  },
  {
    id: 5,
    name: "Mrs. F's New Smile",
    beforeImage: 'https://roseville-smile-revamp.lovable.app/assets/mrs-f-before-DmTzDUBV.jpg',
    afterImage: 'https://roseville-smile-revamp.lovable.app/assets/mrs-f-after-BQVHWe5q.jpg',
    description: "Mrs. F achieved her dream smile through personalized treatment with Dr. Yang.",
  },
  {
    id: 6,
    name: "Mr. L.Y.",
    beforeImage: 'https://customer-assets.emergentagent.com/job_roseville-dental/artifacts/evd1xbde_LY%20Before.jpg',
    afterImage: 'https://customer-assets.emergentagent.com/job_roseville-dental/artifacts/nzvt5gj4_LY%20After.jpg',
    description: "L.Y. wanted to close the gaps in his teeth and fix his grinding. Together with Dr. Yang, they designed a smile that is aesthetic and functional for him!",
  },
  {
    id: 7,
    name: "Nia C.",
    beforeImage: 'https://customer-assets.emergentagent.com/job_roseville-dental/artifacts/m3akxa4g_Nia%20C.%20Before.jpg',
    afterImage: 'https://customer-assets.emergentagent.com/job_roseville-dental/artifacts/kilhi5g1_Nia%20C.%20After%20%281%29.jpg',
    description: "Nia came to Dr. Yang's practice anxious and scared. She had had previous traumatic experiences. Together with Dr. Yang, they were able to get her a smile she was happy to show off. In the process, she also found trust and is now comfortable going to the dentist!",
  },
  {
    id: 8,
    name: "Teri F.",
    beforeImage: 'https://customer-assets.emergentagent.com/job_220f194d-87a3-417c-9226-25ec687de0be/artifacts/874pmtfb_Forbes%2C%20Teri%2004_08_2026%202D%20Oral_Facial%20Photos.jpg',
    afterImage: 'https://customer-assets.emergentagent.com/job_220f194d-87a3-417c-9226-25ec687de0be/artifacts/fwvjbh74_Forbes%2C%20Teri%2005_20_2026%202D%20Oral_Facial%20Photos.jpg',
    description: "Teri came to Sunshine Dental Care with past dental trauma. She was ready for a change. With the help of Dr. Yang and her staff, Teri can now show off her beautiful smile and confidence!",
  },
];

// Main before/after images for the Transform section
export const mainBeforeAfter = {
  before: 'https://www.myrosevilledentist.com/uploads/1/4/5/8/145829117/published/km-before.jpg',
  after: 'https://www.myrosevilledentist.com/uploads/1/4/5/8/145829117/published/km-after.jpg',
};

export const testimonials = [
  {
    id: 1,
    name: 'Sarah M.',
    text: 'Dr. Yang and her team are absolutely wonderful! They made me feel comfortable during my entire treatment. My smile has never looked better!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Michael R.',
    text: "Best dental experience I've ever had. Same day crown service is incredible - no more temporary crowns! Highly recommend.",
    rating: 5,
  },
  {
    id: 3,
    name: 'Jennifer L.',
    text: 'The office is modern and clean, staff is friendly and professional. Dr. Yang is very thorough and explains everything clearly.',
    rating: 5,
  },
];

export const aboutContent = {
  title: 'Restoring Lives, One Smile at a Time',
  paragraphs: [
    'Dentistry is more than teeth. Your relationship with your health care provider is key to quality of care. I believe in patient-centered, comprehensive, quality dental care, while building lasting relationships with each person. Together, we can address your oral health concerns through education, prevention, and quality dental care. We are a family-centered practice, and love to take care of families when possible. I look forward to meeting you and empowering you take care of your dental health.',
    "When I'm not at the office, I enjoy spending time with my family. My husband David, our daughters Madison and Lois, and I are also avid foodies and adventurers. I love to read, travel, be outdoors, and just enjoy the company of loved ones.",
  ],
  doctor: {
    name: 'Dr. Maichou Yang',
    title: 'DDS - Family & Cosmetic Dentistry',
    image: 'https://roseville-smile-revamp.lovable.app/assets/dr-yang-about-C4Bw9m2L.jpeg',
  },
};

export const aboutFeatures = [
  { title: 'Expert Care', description: "Dr. Yang's extensive training ensures top-quality results", icon: 'Award' },
  { title: 'Patient-Focused', description: 'Your comfort and well-being are our top priorities', icon: 'Heart' },
  { title: 'Family Friendly', description: 'Comprehensive care for patients of all ages', icon: 'Users' },
  { title: 'Modern Technology', description: 'State-of-the-art equipment for efficient treatment', icon: 'Cpu' },
];

export const staffMembers = [
  {
    id: 1,
    name: 'Arianna',
    role: 'Office Manager',
    description: 'Committed to making every patient feel comfortable and welcome',
    image: 'https://roseville-smile-revamp.lovable.app/assets/arianna-DY5mWzzm.jpg',
  },
  {
    id: 2,
    name: 'Bao',
    role: 'Dental Assistant',
    description: 'Dedicated to providing excellent patient care and support',
    image: 'https://roseville-smile-revamp.lovable.app/assets/bao-vang-CctbCQFq.jpg',
  },
];

export const servingAreas = [
  'Roseville', 'Rocklin', 'Lincoln', 'Citrus Heights', 'Sacramento', 'Granite Bay', 'Fair Oaks', 'Auburn', 'Orangevale', 'Loomis', 'Elk Grove', 'West Sacramento'
];

export const contactInfo = {
  phone: '(916) 773-1122',
  address: '700 Sunrise Ave, Ste E',
  city: 'Roseville, CA 95661',
  hours: 'Monday - Wednesday: 7:00 AM - 3:30 PM',
  mapUrl: 'https://maps.google.com/?q=700+Sunrise+Ave+Ste+E+Roseville+CA+95661',
  googleReviewsUrl: 'https://www.google.com/maps/search/?api=1&query=Sunshine+Dental+Care+700+Sunrise+Ave+Roseville+CA+95661',
};

export const images = {
  hero: 'https://roseville-smile-revamp.lovable.app/assets/hero-dental-BiKwPMMR.jpg',
  dentalRoom: 'https://roseville-smile-revamp.lovable.app/assets/dental-room-BxBTQ9YS.jpg',
  drYang: 'https://roseville-smile-revamp.lovable.app/assets/dr-yang-about-C4Bw9m2L.jpeg',
  beforeAfter: {
    before: 'https://www.myrosevilledentist.com/uploads/1/4/5/8/145829117/published/km-before.jpg',
    after: 'https://www.myrosevilledentist.com/uploads/1/4/5/8/145829117/published/km-after.jpg',
  },
};
